"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Avatar_1 = __importDefault(require("@mui/material/Avatar"));
var ListItemAvatar_1 = __importDefault(require("@mui/material/ListItemAvatar"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var ListItem_1 = __importDefault(require("@mui/material/ListItem"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var DiscountPrice = __importStar(require("./A_DiscountPrice"));
function Component(props) {
    return (Preact.h(ListItem_1.default, { alignItems: "flex-start", sx: { height: '64px', paddingY: '10px' } },
        props.imageUrl && (Preact.h(Box_1.default, { paddingRight: "10px" },
            Preact.h(ListItemAvatar_1.default, { sx: {
                    marginTop: 0,
                    '& .MuiAvatar-img': {
                        objectFit: 'contain',
                    },
                    '& .MuiAvatar-root': {
                        border: '1px solid rgba(0,0,0,0.08)',
                    },
                } },
                Preact.h(Avatar_1.default, { variant: "rounded", alt: props.productName, src: props.imageUrl })))),
        Preact.h(Box_1.default, { sx: {
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                height: '100%',
                alignItems: 'flex-start',
            } },
            Preact.h(ListItemText_1.default, { primary: props.productName, sx: {
                    margin: 'unset',
                    color: '#1F2937',
                    paddingTop: '2px',
                }, primaryTypographyProps: {
                    sx: {
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        width: { xs: '200px', md: '250px' },
                        display: '-webkit-box',
                        '-webkit-box-orient': 'vertical',
                        '-webkit-line-clamp': '1',
                    },
                } }),
            Preact.h(Box_1.default, { display: "flex", flexDirection: "column" },
                Preact.h(Typography_1.default, { textAlign: "right", variant: "h6", color: "#1F2937" }, props.productPrice),
                props.originalPrice && (Preact.h(DiscountPrice.Component, { discount: props.originalPrice, sx: { textAlign: 'right', paddingTop: '2px' } }))))));
}
exports.Component = Component;
